module.exports = __webpack_public_path__ + "static/media/1-cn.7e15b4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/PhuketSkypark/sitePlan/svg/a/img/1-cn.png
// module id = 942
// module chunks = 0